// @flow

import React from 'react'
import { useIntl } from 'gatsby-plugin-intl'
import { applyStylingHoc, type StyleOuterProps, type StyleProps } from '@fcse/tsbob/dist/lib/styling'
import classNames from 'classnames'
import ScrollAnimation from 'react-animate-on-scroll'
import { Container, Row, Col } from '../../../components/basic/Grid'
import messages from '../CaseStudy.lang'
import baseStyles from './CaseRoadmap.scss'

type Props = {
  ...StyleProps,
  title?: string,
  roadmap: Array<Object>
}

const CaseRoadmap = ({ styles, title, roadmap }: Props) => {
  const { formatMessage } = useIntl()

  return (
    <div className={styles.root}>
      <ScrollAnimation className={styles.animationContainer} animateIn="fadeInUp" animateOnce animatePreScroll={false}>
        <Container className={styles.container} fluid>
          <h3 className={styles.title}>{title ? formatMessage(title) : formatMessage(messages.roadmapTitle)}</h3>
          <Row>
            {roadmap.map((item, i) => {
              return (
                <Col xs="12" md="3" className={styles.col} key={'caseStat' + i}>
                  <span className={classNames(styles.icon, item.icon, styles['is-' + item.color])} />
                  <span className={styles.itemContent}>
                    <span className={styles.itemTitle}>
                      <b>{i + 1}&nbsp;</b>
                      {formatMessage(item.title)}
                    </span>
                    <span className={styles.time}>
                      {item.timeLabel && <span>{`${formatMessage(item.timeLabel)} `}</span>}
                      {item.timeValue && item.timeValue}
                      {item.timeMeasure && <span>{` ${formatMessage(item.timeMeasure)}`}</span>}
                    </span>
                  </span>
                </Col>
              )
            })}
          </Row>
        </Container>
      </ScrollAnimation>
    </div>
  )
}

export default applyStylingHoc(baseStyles)<$Diff<Props, StyleProps> & StyleOuterProps, Function>(CaseRoadmap)
